import axios from "axios";
import { eventBus } from "@/main";

const moduleReport = {
  namespaced: true,
  state: {
    reportDateRange: []
  },
  mutations: {
    setReportDateRange(state, data) {
      state.reportDateRange = data ? data : [];
    }
  },
  actions: {
    fetchReportBranchDoctorIncome({ commit }, payload) {
      return axios
        .get(
          `/api/report/branchDoctorIncome/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchReportBranchReceiptItem({ commit }, payload) {
      return axios
        .get(
          `/api/report/receiptItem/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt,
              receiptStatus: payload.receiptStatus
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    // --- Clinic-wide roll-up (รายงานรายได้คลินิก): sums every branch the caller
    // is scoped to. No branchUrl segment; the backend resolves the branch set. ---
    fetchClinicReportReceiptItem({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/receiptItem/${payload.clinicUrl}`, {
          params: {
            startDt: payload.startDt,
            endDt: payload.endDt,
            receiptStatus: payload.receiptStatus
          }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchClinicBranchReceipt({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/branchReceipt/${payload.clinicUrl}`, {
          params: {
            startDt: payload.dateFrom,
            endDt: payload.dateTo,
            receiptStatus: payload.receiptStatus
          }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchClinicLabExpense({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/labExpense/${payload.clinicUrl}`, {
          params: payload.event
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchClinicDoctorIncome({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/doctorIncome/${payload.clinicUrl}`, {
          params: {
            startDt: payload.startDt,
            endDt: payload.endDt
          }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchClinicDiscountUsageReport({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/discountUsage/${payload.clinicUrl}`, {
          params: {
            startDt: payload.startDt,
            endDt: payload.endDt
          }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchClinicDiscountUsageReportLines({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/discountUsage/${payload.clinicUrl}/lines`, {
          params: {
            startDt: payload.startDt,
            endDt: payload.endDt,
            branchId: payload.branchId,
            discountId: payload.discountId,
            actionUid: payload.actionUid
          }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchDiscountUsageReport({ commit }, payload) {
      return axios
        .get(
          `/api/report/discountUsage/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchDiscountUsageReportLines({ commit }, payload) {
      return axios
        .get(
          `/api/report/discountUsage/${payload.clinicUrl}/${payload.branchUrl}/lines`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt,
              discountId: payload.discountId,
              actionUid: payload.actionUid
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchDepositMovementReport({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/depositMovement/${payload.clinicUrl}`, {
          params: { startDt: payload.startDt, endDt: payload.endDt }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchDepositBalanceReport({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/depositBalance/${payload.clinicUrl}`, {
          params: payload.asOf ? { asOf: payload.asOf } : {}
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchDepositLinesReport({ commit }, payload) {
      return axios
        .get(`/api/report/clinic/depositLines/${payload.clinicUrl}`, {
          params: {
            startDt: payload.startDt,
            endDt: payload.endDt,
            type: payload.type,
            patientId: payload.patientId,
            offset: payload.offset,
            limit: payload.limit
          }
        })
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchBranchDepositMovementReport({ commit }, payload) {
      return axios
        .get(
          `/api/report/deposit/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: { startDt: payload.startDt, endDt: payload.endDt }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchBranchDepositLinesReport({ commit }, payload) {
      return axios
        .get(
          `/api/report/deposit/${payload.clinicUrl}/${payload.branchUrl}/lines`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt,
              type: payload.type,
              offset: payload.offset,
              limit: payload.limit
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    fetchReportBranchReceipt({ commit }, payload) {
      return axios
        .get(
          `/api/report/branchReceipt/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              receiptStatus: payload.receiptStatus
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    async emailReportBranchReceipt({ commit }, payload) {
      return axios
        .get(
          `/api/v2/report/branchReceipt/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              receiptStatus: payload.receiptStatus
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchReportDoctorReceiptItem({ commit }, payload) {
      return axios
        .get(
          `/api/report/receiptItem/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              actionUid: payload.actionUid
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    emailReportPaymentMethod({ commit }, payload) {
      return axios
        .get(
          `/api/v2/report/receiptPayment/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              groupBy: payload.groupBy || "day"
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchReportPaymentMethod({ commit }, payload) {
      return axios
        .get(
          `/api/report/receiptPayment/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              groupBy: payload.groupBy || "day"
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchOverdueItemsReport({ commit }, payload) {
      return axios
        .get(
          `/api/report/branchReceiptItemOverdue/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchPatientPaymentItem({ commit }, payload) {
      let url = `/api/report/patientReceiptItem/${payload.clinicUrl}/${payload.branchUrl}/${payload.patientID}`;
      return axios
        .get(url)
        .then(res => {
          return res.data.report;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchPatientPaymentReceipt({ commit }, payload) {
      let url = `/api/report/patientReceipt/${payload.clinicUrl}/${payload.branchUrl}/${payload.patientID}`;
      return axios
        .get(url)
        .then(res => {
          return res.data.report;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    fetchDfByPaymentType({ commit }, payload) {
      return axios
        .get(
          `/api/report/dfByPaymentType/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              groupBy: payload.groupBy || "day",
              actionUid: payload.actionUid
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    emailDfByPaymentType({ commit }, payload) {
      return axios
        .get(
          `/api/v2/report/dfByPaymentType/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.dateFrom,
              endDt: payload.dateTo,
              groupBy: payload.groupBy || "day",
              actionUid: payload.actionUid
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    //--------- State ---------//
    setStateReportDateRange({ commit }, data) {
      commit("setReportDateRange", data);
    }
  },
  getters: {
    getReportDateRange: state => {
      return state.reportDateRange;
    }
  }
};
export default moduleReport;
